import { render, staticRenderFns } from "./detailecomparePrioduct.vue?vue&type=template&id=4dc3e26c&scoped=true&"
import script from "./detailecomparePrioduct.vue?vue&type=script&lang=js&"
export * from "./detailecomparePrioduct.vue?vue&type=script&lang=js&"
import style0 from "./detailecomparePrioduct.vue?vue&type=style&index=0&id=4dc3e26c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3e26c",
  null
  
)

export default component.exports